import request from '@/utils/request'

const api = {
  getWorkList: '/user/User/rosterList',
  getWork: `/user/User/`,
  updateWork: `/user/User/`,
  userRegister: '/user/User/register',
  deleteWorker: '/user/User/',
  updateUserEntryStatus: '/user/User/updateUserEntryStatus'
}

export default api

/**
   * 查询劳务人员表 劳务工人花名册创建列表
   * @param {object} parameter
   */
export function getWorkList (parameter) {
  return request({
    url: api.getWorkList,
    method: 'get',
    params: parameter
  })
}
/**
   * 查询劳务人员表 更新进退场状态
   * @param {object} parameter
   */
export function updateUserEntryStatus (parameter) {
  return request({
    url: `/user/User/updateUserEntryStatus/${parameter.orgId}/${parameter.userId}/${parameter.entryStatus}`,
    method: 'get',
    params: parameter
  })
}
/**
   * 人员表 判断电话号码是否被注册
   * @param {object} parameter
   */
export function phoneIssentUsed (parameter) {
  return request({
    url: '/user/User/phoneIssentUsed',
    method: 'get',
    params: parameter
  })
}
/**
   * 查询劳务人员表 劳务工人花名册保存
   * @param {object} parameter
   */
export function userRegister (parameter) {
  return request({
    url: api.userRegister,
    method: 'post',
    data: parameter
  })
}
/**
   * 查询劳务人员表 劳务工人花名册删除
   * @param {object} parameter
   */
export function deleteWorker (parameter) {
  return request({
    url: `${api.deleteWorker}${parameter.id}`,
    method: 'delete'
  })
}
/**
   * 查询劳务人员表 劳务工人花名册批量删除
   * @param {object} parameter
   */
export function batchDelete (parameter) {
  return request({
    url: `/user/User/batchDelete`,
    method: 'delete',
    data: parameter
  })
}
/**
   * 查询劳务人员表 劳务工人花名册详情
   * @param {object} parameter
   */
export function getWork (parameter) {
  return request({
    url: `${api.getWork}${parameter.id}`,
    method: 'get',
    params: parameter
  })
}
/**
   * 查询劳务人员表 劳务工人花名册修改
   * @param {object} parameter
   */
export function updateWork (parameter) {
  return request({
    url: `${api.updateWork}`,
    method: 'put',
    data: parameter
  })
}
/**
   * 账号管理-保存新接口
   * @param {object} parameter
   */
export function saveUserInWorkAccount (parameter) {
  return request({
    url: `user/User/saveUserInWorkAccount`,
    method: 'post',
    data: parameter
  })
}
/**
   * 账号管理-编辑新接口
   * @param {object} parameter
   */
export function updateUserInWorkAccount (parameter) {
  return request({
    url: `user/User/updateUserInWorkAccount`,
    method: 'put',
    data: parameter
  })
}

// --------------------------打卡记录------------------------------

/**
 * 获取打卡记录列表
 * @param {object} parameter
 * @property {string} name 人员姓名
 * @property {string} entrTime 进场时间，yyyy-MM-dd HH:mm:ss
 * @property {string} exitTime 	出场时间，yyyy-MM-dd HH:mm:ss
 * @property {string} orgId 	组织Id
 */
export function getClockRecord (parameter) {
  return request({
    url: '/clock/getClockRecord',
    method: 'get',
    params: parameter
  })
}

/**
 * 获取打卡记录详情记录
 * @param {object} parameter
 * @property {number} id id
 */
export function getClockToday (parameter) {
  return request({
    url: '/clock/getClockToday',
    method: 'get',
    params: parameter
  })
}
/** 【打卡记录】查询打卡记录表列表
 * @param {object} parameter
 * @property {string} keyWord 姓名
 */
export function UserAttendanceList (parameter) {
  return request({
    url: '/user/UserAttendance/list',
    get: 'post',
    params: parameter
  })
}
/** 【打卡记录】详细
 * @param {object} parameter
 * @property {string} keyWord 姓名
 */
export function getUserAttendance (parameter) {
  return request({
    url: `/UserAttendance/${parameter.id}`,
    get: 'post',
    params: parameter
  })
}
/** 【打卡记录】获取人脸机设备列表
 * @param {object} parameter
 */
export function listFaceDevice (parameter) {
  return request({
    url: `user/FaceGroup/listFaceDevice`,
    method: 'get',
    params: parameter
  })
}
/** 【打卡记录】获取人脸机设备分组列表
 * @param {object} parameter
 */
export function listFaceGroup (parameter) {
  return request({
    url: `user/FaceGroup/listFaceGroup`,
    method: 'get',
    params: parameter
  })
}
/** 【打卡记录】保存人脸机设备分组
 * @param {object} parameter
 */
export function saveFaceGroup (parameter) {
  return request({
    url: `user/FaceGroup/saveFaceGroup`,
    method: 'post',
    data: parameter
  })
}
/** 【考勤统计】列表
 * @param {object} parameter
 * @property {string} keyWord 姓名
 * @property {string} searchAround 1本周，2本月，3本季度
 */
export function UserAttendanceStatistics (parameter) {
  return request({
    url: '/user/UserAttendanceStatistics/list',
    get: 'post',
    params: parameter
  })
}

/**
 * 【人员定位】修改
 * @param {object} parameter
 * @property {String} userId 用户id
 * @property {String} cardNum 定位卡号
 */
export function updateUserInfo (parameter) {
  return request({
    url: `/user/UserInfo/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【人员定位】详细
 * @param {object} parameter
 * @property {String} userId 用户id
 */
export function getUserInfo (parameter) {
  return request({
    url: `/user/UserInfo/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【人员定位】列表
 * @param {object} parameter
 * @property {String} search 姓名/手机号/定位卡号搜索
 * @property {String} bindingStatus 绑定状态（1绑定中 2绑定成功 3绑定失败）
 */
export function userInfoList (parameter) {
  return request({
    url: `/user/UserInfo/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【人员定位】定位卡号列表
 * @param {object} parameter
 */
export function listCardNum (parameter) {
  return request({
    url: `/user/UserInfo/listCardNum`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【人员定位】解除绑定
 * @param {object} parameter
 */
export function cancelBinding (parameter) {
  return request({
    url: `/user/UserInfo/cancelBinding`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【进度计划管理】保存
 * @param {object} parameter
 */
export function saveProgressPlanManage (parameter) {
  return request({
    url: `/AY220052Z/ProgressPlanManage/`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【进度计划管理】修改
 * @param {object} parameter
 */
export function updateProgressPlanManage (parameter) {
  return request({
    url: `/AY220052Z/ProgressPlanManage/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【进度计划管理】列表
 * @param {object} parameter
 */
export function getProgressPlanManageList (parameter) {
  return request({
    url: `/AY220052Z/ProgressPlanManage/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【进度计划管理】详细
 * @param {object} parameter
 */
export function getProgressPlanManage (parameter) {
  return request({
    url: `/AY220052Z/ProgressPlanManage/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【进度计划管理】删除
 * @param {object} parameter
 */
export function deleteProgressPlanManage (parameter) {
  return request({
    url: `/AY220052Z/ProgressPlanManage/${parameter.id}`,
    method: 'delete'
  })
}

/**
   * 【工人花名册】工种列表
   * @param {object} parameter
   */
export function WorkerTypeDictList (parameter) {
  return request({
    url: `/WorkerTypeDict/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【劳工上岛报审】删除
 * @param {object} parameter
 */
export function deleteLaborIslandApply (parameter) {
  return request({
    url: `/LaborIslandApply/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 【上岛报审】查询报审四个指标
 * @param {object} parameter
 */
export function getLaborFourIndex (parameter) {
  return request({
    url: `/LaborPersonnelApproval/getLaborFourIndex`,
    method: 'get'
  })
}

/**
 * 【劳工上岛报审】查看
 * @param {object} parameter
 */
export function getLaborIslandApply (parameter) {
  return request({
    url: `/LaborIslandApply/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 【劳工上岛报审】列表
 * @param {object} parameter
 */
export function getLaborIslandApplyList (parameter) {
  return request({
    url: `/LaborIslandApply/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【报审人员】查看详情
 * @param {object} parameter
 */
export function getLaborPersonnelApprovalDetail (parameter) {
  return request({
    url: `/LaborPersonnelApproval/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【报审人员】列表
 * @param {object} parameter
 */
export function getLaborPersonnelApprovalList (parameter) {
  return request({
    url: `/LaborPersonnelApproval/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 获取组织详细
 * @param {object} parameter
 * @property {number} id 组织唯一标识
 */
export function getOrg (parameter) {
  return request({
    url: `/Organization/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 班组详细信息
 * @param {object} parameter
 * @property {number} id 唯一标识
 */
export function getOrganizationTeam (parameter) {
  return request({
    url: `/Organization/team/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【劳工上岛报审】保存
 * @param {object} parameter
 */
export function saveLaborIslandApply (parameter) {
  return request({
    url: `/LaborIslandApply/`,
    method: 'post',
    data: parameter
  })
}

/**
 * 【报审人员】预约人数统计
 * @param {object} parameter
 */
export function queryLaborAboutNum (parameter) {
  return request({
    url: `/LaborPersonnelApproval/queryLaborAboutNum`,
    method: 'get'
  })
}

/**
 * 【报审人员】发起预约
 * @param {object} parameter
 */
export function initiateReservationApplication (parameter) {
  return request({
    url: `/LaborPersonnelApproval/initiateReservationApplication`,
    method: 'post',
    data: parameter
  })
}

/**
 * 【报审人员】确认未进场
 * @param {object} parameter
 */
export function queryLaborEnterStatus (parameter) {
  return request({
    url: `/LaborPersonnelApproval/noEnter/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 识别营业执照
 * @param {object} parameter
 * @property {number} url 营业执照地址
 */
export function recognitionBusinessLicense (parameter) {
  return request({
    url: `/Organization/businessLicense`,
    method: 'post',
    data: parameter
  })
}

/**
 * 【劳工上岛报审】修改
 * @param {object} parameter
 */
export function updateLaborIslandApply (parameter) {
  return request({
    url: `/LaborIslandApply/`,
    method: 'put',
    data: parameter
  })
}

/**
   * 【工人花名册】左侧树
   * @param {object} parameter
   */
export function orgTreeList (parameter) {
  return request({
    url: `/Organization/orgTreeList`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【报审人员】修改
 * @param {object} parameter
 */
export function updateLaborPersonnelApproval (parameter) {
  return request({
    url: `/LaborPersonnelApproval/`,
    method: 'put',
    data: parameter
  })
}

// --------------------------劳务管理-智能手环系统------------------------------

/**
 * 查询手环列表
 * @param {object} parameter
 */
export function getBraceletList (parameter) {
  return request({
    url: '/user/LocationCard/listBracelet',
    method: 'get',
    params: parameter
  })
}

/**
 * 手环解除绑定
 * @param {object} parameter
 */
export function braceletUnBinding (parameter) {
  return request({
    url: '/user/LocationCard/braceletUnBinding',
    method: 'put',
    data: parameter
  })
}

/**
 * 查询手环绑定详情
 * @param {object} parameter
 */
export function getBraceletById (parameter) {
  return request({
    url: `/user/LocationCard/getById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 手环绑定
 * @param {object} parameter
 */
export function braceletBinding (parameter) {
  return request({
    url: '/user/LocationCard/braceletBinding',
    method: 'put',
    data: parameter
  })
}

/**
 * 新增手环
 * @param {object} parameter
 */
export function saveLocationCard (parameter) {
  return request({
    url: '/user/LocationCard/',
    method: 'post',
    data: parameter
  })
}

/**
 * 查询手环预警信息列表
 * @param {object} parameter
 */
export function getBraceletWarnInfoList (parameter) {
  return request({
    url: '/user/BraceletWarnInfo/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 更新手环预警信息
 * @param {object} parameter
 */
export function updateBraceletWarnInfo (parameter) {
  return request({
    url: '/user/BraceletWarnInfo/',
    method: 'put',
    data: parameter
  })
}

/**
 * 批量更新手环预警信息
 * @param {object} parameter
 */
export function updateBatchBraceletWarnInfo (parameter) {
  return request({
    url: '/user/BraceletWarnInfo/batchUpdate',
    method: 'put',
    data: parameter
  })
}

/**
 * 批量保存手环阈值配置
 * @param {object} parameter
 */
export function batchSave (parameter) {
  return request({
    url: '/user/BraceletThresholdConfig/batchSave',
    method: 'post',
    data: parameter
  })
}

/**
 * 查询手环阈值配置列表
 * @param {object} parameter
 */
export function getBraceletThresholdConfig (parameter) {
  return request({
    url: '/user/BraceletThresholdConfig/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 在岗及预警统计
 * @param {object} parameter
 */
export function getBraceletWarnInfoStatistics (parameter) {
  return request({
    url: '/user/BraceletWarnInfo/dailyStatistics',
    method: 'get',
    params: parameter
  })
}

/**
 * 人员轨迹
 * @param {object} parameter
 */
export function getCoordinatePosition (parameter) {
  return request({
    url: '/user/WorkCardLocation/coordinatePosition',
    method: 'get',
    params: parameter
  })
}

/**
 * 各预警类型占比分析
 * @param {object} parameter
 */
export function getTypeProportionAnalysis (parameter) {
  return request({
    url: '/user/BraceletWarnInfo/typeProportionAnalysis',
    method: 'get',
    params: parameter
  })
}

/**
 * 当日在场人数监测
 * @param {object} parameter
 */
export function getAttendanceMonitoring (parameter) {
  return request({
    url: '/user/WorkCardLocation/attendanceMonitoring',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询手环绑定人员信息列表
 * @param {object} parameter
 */
export function getBindingUserInfoList (parameter) {
  return request({
    url: '/user/LocationCard/bindingUserInfoList',
    method: 'get',
    params: parameter
  })
}

/**
 * 查询手环绑定人员详细信息
 * @param {object} parameter
 */
export function getBindingUserInfo (parameter) {
  return request({
    url: `/user/LocationCard/bindingUserInfo/${parameter.userId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 人员手环监测信息
 * @param {object} parameter
 */
export function getMonitoringInformation (parameter) {
  return request({
    url: `/user/LocationCard/monitoringInformation/${parameter.userId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 全天平均心率
 * @param {object} parameter
 */
export function getTodayPulseStatistics (parameter) {
  return request({
    url: `/user/WatchData/todayPulseStatistics/${parameter.userId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 全天平均步数
 * @param {object} parameter
 */
export function getTodayMarchStatistics (parameter) {
  return request({
    url: `/user/WatchData/todayMarchStatistics/${parameter.userId}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 人员历史轨迹坐标
 * @param {object} parameter
 */
export function getHistoricalRoute (parameter) {
  return request({
    url: `/user/WorkCardLocation/historicalRoute`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询用户该月份下哪些日期有运动轨迹
 * @param {object} parameter
 */
export function getHistoricalRouteDate (parameter) {
  return request({
    url: `/user/WorkCardLocation/historicalRouteDate`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询手环预警信息详情
 * @param {object} parameter
 */
export function getBraceletWarnInfo (parameter) {
  return request({
    url: `/user/BraceletWarnInfo/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

// #region --------------------------考勤二维码------------------------------

/**
   * 查询考勤二维码配置列表
   * @param {object} parameter
   */
export function getUserAttendanceQrConfigList (parameter) {
  return request({
    url: '/user/UserAttendanceQrConfig/list',
    method: 'get',
    params: parameter
  })
}
/**
   * 查询劳务人员表 劳务工人花名册保存
   * @param {object} parameter
   */
export function saveUserAttendanceQrConfig (parameter) {
  return request({
    url: '/user/UserAttendanceQrConfig/',
    method: 'post',
    data: parameter
  })
}
/**
   * 查询劳务人员表 劳务工人花名册删除
   * @param {object} parameter
   */
export function deleteUserAttendanceQrConfig (parameter) {
  return request({
    url: `/user/UserAttendanceQrConfig/${parameter.id}`,
    method: 'delete'
  })
}
/**
   * 查询劳务人员表 劳务工人花名册详情
   * @param {object} parameter
   */
export function getUserAttendanceQrConfig (parameter) {
  return request({
    url: `/user/UserAttendanceQrConfig/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}
/**
   * 查询劳务人员表 劳务工人花名册修改
   * @param {object} parameter
   */
export function updateUserAttendanceQrConfig (parameter) {
  return request({
    url: '/user/UserAttendanceQrConfig/',
    method: 'put',
    data: parameter
  })
}

// #endregion

// #region --------------------------劳务管理-作业票管理------------------------------

/**
 * 查询作业票管理列表
 * @param {object} parameter
 */
export function getListTicketManage (parameter) {
  return request({
    url: `user/TicketManage/listTicketManage`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询作业票管理详情
 * @param {object} parameter
 */
export function getTicketManageById (parameter) {
  return request({
    url: `user/TicketManage/getTicketManageById/${parameter.id}`,
    method: 'get',
    params: parameter
  })
}

/**
 * 作业票管理列表删除
 * @param {object} parameter
 */
export function deleteTicketManageById (parameter) {
  return request({
    url: `user/TicketManage/deleteTicketManageById/${parameter.id}`,
    method: 'delete',
    data: parameter
  })
}

/**
 * 作业票管理保存
 * @param {object} parameter
 */
export function saveTicketManage (parameter) {
  return request({
    url: `user/TicketManage/saveTicketManage`,
    method: 'post',
    data: parameter
  })
}

/**
 * 作业票管理修改
 * @param {object} parameter
 */
export function updateTicketManage (parameter) {
  return request({
    url: `user/TicketManage/updateTicketManage`,
    method: 'put',
    data: parameter
  })
}

/**
   * 客商信息列表
   * @param {object} parameter
   */
export function getOrgSupplierList (parameter) {
  return request({
    url: `/org/Organization/getOrgSupplierList`,
    method: 'get',
    params: parameter
  })
}

/**
 * 班组列表
 * @param {object} parameter
 */
export function getTeamsListByOrgId (parameter) {
  return request({
    url: `/user/Teams/teamsListByOrgId`,
    method: 'get',
    params: parameter
  })
}

// #endregion

// #region --------------------------用餐记录------------------------------

/**
 * 查询用餐记录列表
 * @param {object} parameter
 */
export function listDiningRecord (parameter) {
  return request({
    url: `user/DiningRecord/listDiningRecord`,
    method: 'get',
    params: parameter
  })
}

/**
 * 查询用餐记录详情
 * @param {object} parameter
 */
export function getDiningRecordById (parameter) {
  return request({
    url: `user/DiningRecord/getDiningRecordById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 删除用餐记录
 * @param {object} parameter
 */
export function deleteDiningRecordById (parameter) {
  return request({
    url: `user/DiningRecord/deleteDiningRecordById/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 保存用餐记录
 * @param {object} parameter
 */
export function saveDiningRecord (parameter) {
  return request({
    url: `user/DiningRecord/saveDiningRecord`,
    method: 'post',
    data: parameter
  })
}

/**
 * 修改用餐记录
 * @param {object} parameter
 */
export function updateDiningRecord (parameter) {
  return request({
    url: `user/DiningRecord/updateDiningRecord`,
    method: 'put',
    data: parameter
  })
}

// #endregion

// #region --------------------------电子围栏------------------------------

/**
 * 查询电子围栏表列表
 * @param {object} parameter
 */
export function listElectronicFence (parameter) {
  return request({
    url: `/user/ElectronicFence/listElectronicFence`,
    method: 'get',
    params: parameter
  })
}

/**
 * 修改批量电子围栏表
 * @param {object} parameter
 */
export function updateElectronicFence (parameter) {
  return request({
    url: '/user/ElectronicFence/updateElectronicFence',
    method: 'put',
    data: parameter
  })
}

/**
 * 修改电子围栏状态
 * @param {object} parameter
 */
export function updateElectronicFenceStatus (parameter) {
  return request({
    url: '/user/ElectronicFence/updateStatus',
    method: 'put',
    data: parameter
  })
}
/**
 * 保存批量电子围栏表
 * @param {object} parameter
 */
export function saveElectronicFence (parameter) {
  return request({
    url: '/user/ElectronicFence/saveElectronicFence',
    method: 'post',
    data: parameter
  })
}

/**
 * 根据id删除电子围栏表
 * @param {object} parameter
 */
export function deleteElectronicFenceById (parameter) {
  return request({
    url: `/user/ElectronicFence/deleteElectronicFenceById/${parameter.id}`,
    method: 'delete'
  })
}
// #endregion

// #region --------------------------党建活动评比------------------------------/

/**
 * 【党建活动评比】列表
* @param {object} parameter
*/
export function listPartyBuildEvaluation (parameter) {
  return request({
    url: '/user/PartyBuildEvaluation/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 【党建活动评比】责任区范围列表
* @param {object} parameter
*/
export function listPartyBuildEvaluationArea (parameter) {
  return request({
    url: '/user/PartyBuildEvaluationArea/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 【党建活动评比】责任区范围保存
* @param {object} parameter
*/
export function savePartyBuildEvaluationArea (parameter) {
  return request({
    url: '/user/PartyBuildEvaluationArea/',
    method: 'post',
    data: parameter
  })
}

/**
 * 【党建活动评比】保存
* @param {object} parameter
*/
export function savePartyBuildEvaluation (parameter) {
  return request({
    url: '/user/PartyBuildEvaluation/',
    method: 'post',
    data: parameter
  })
}

/**
 * 【党建活动评比】修改
* @param {object} parameter
*/
export function updatePartyBuildEvaluation (parameter) {
  return request({
    url: '/user/PartyBuildEvaluation/',
    method: 'put',
    data: parameter
  })
}

/**
 * 【党建活动评比】删除
* @param {object} parameter
*/
export function deletePartyBuildEvaluationById (parameter) {
  return request({
    url: `/user/PartyBuildEvaluation/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 【党建活动评比】查看
* @param {object} parameter
*/
export function getPartyBuildEvaluationById (parameter) {
  return request({
    url: `/user/PartyBuildEvaluation/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 【打卡设备配置】保存打卡设备分组
 * @param {object} parameter
 */
export function saveAttendanceDeviceGroup (parameter) {
  return request({
    url: '/user/AttendanceDeviceGroup/saveAttendanceDeviceGroup',
    method: 'post',
    data: parameter
  })
}

/**
 * 【打卡设备配置】根据id删除打卡设备分组
 * @param {object} parameter
 */
export function deleteAttendanceDeviceGroupById (parameter) {
  return request({
    url: `/user/AttendanceDeviceGroup/deleteAttendanceDeviceGroupById/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 【打卡设备配置】修改打卡设备分组
 * @param {object} parameter
 */
export function updateAttendanceDeviceGroup (parameter) {
  return request({
    url: '/user/AttendanceDeviceGroup/updateAttendanceDeviceGroup',
    method: 'put',
    data: parameter
  })
}

/**
 * 【打卡设备配置】查询打卡设备分组列表
 * @param {object} parameter
 */
export function listAttendanceDeviceGroup (parameter) {
  return request({
    url: '/user/AttendanceDeviceGroup/listAttendanceDeviceGroup',
    method: 'get',
    params: parameter
  })
}

/**
 * 【打卡设备配置】查询打卡设备分组详情
 * @param {object} parameter
 */
export function getAttendanceDeviceGroupById (parameter) {
  return request({
    url: `/user/AttendanceDeviceGroup/getAttendanceDeviceGroupById/${parameter.id}`,
    method: 'get'
  })
}

/**
 * 【打卡设备配置】查询人脸机设备列表
 * @param {object} parameter
 */
export function listAttendanceFaceDevice (parameter) {
  return request({
    url: 'user/FaceGroup/listFaceDevice',
    method: 'get',
    params: parameter
  })
}
